import React from 'react';
import * as RadixContextMenu from '@radix-ui/react-context-menu';

import { ContextMenuContent } from './ContextMenuContent';
import { ContextMenuItem } from './ContextMenuItem';

const ContextMenuRoot = (props: RadixContextMenu.ContextMenuProps) => {
  return <RadixContextMenu.Root {...props} />;
};

export const ContextMenu = Object.assign(ContextMenuRoot, {
  Portal: RadixContextMenu.Portal,
  Trigger: RadixContextMenu.Trigger,
  Content: ContextMenuContent,
  Sub: RadixContextMenu.Sub,
  SubTrigger: RadixContextMenu.SubTrigger,
  SubContent: RadixContextMenu.SubContent,
  Item: ContextMenuItem,
  Separator: RadixContextMenu.Separator,
  Group: RadixContextMenu.Group,
  CheckboxItem: RadixContextMenu.CheckboxItem,
  RadioItem: RadixContextMenu.RadioItem,
  RadioGroup: RadixContextMenu.RadioGroup,
});
